import { useAppSession } from '@/providers/AppSessionProvider';
import { useAdminSimulate } from '@/providers/AdminSimulateProvider';

/**
 * Hook that returns the effective user ID for the current session.
 * If admin is simulating a user, returns the simulated user ID.
 * Otherwise returns the actual authenticated user ID.
 * 
 * This should be used throughout the app to ensure admin simulation works correctly.
 */
export function useEffectiveUserId(): string | undefined {
  const { session } = useAppSession();
  const { isSimulating, simulatedUserId } = useAdminSimulate();
  
  // If simulating, use simulated user ID
  if (isSimulating && simulatedUserId) {
    return simulatedUserId;
  }
  
  // Otherwise use actual session user ID
  return session?.user?.id;
}
